import React from 'react';
import { ShieldCheck, Lock, CreditCard, Zap, Download } from 'lucide-react';
import { OfferSelector } from './OfferSelector';
import { UrgencyBanner } from './UrgencyBanner';
export function Pricing() {
  return <section className="bg-crema py-10 sm:py-16 px-5 text-center" id="precios" data-id="element-273">
      <h2 className="text-[clamp(22px,4vw,34px)] font-extrabold leading-[1.2] mb-2 text-oscuro" data-id="element-274">
        Elegí tu Kit Profesional
      </h2>
      <p className="text-[15px] text-gris mb-6 sm:mb-8" data-id="element-275">
        Ambas opciones incluyen los 3 bonos estratégicos completos
      </p>

      <UrgencyBanner data-id="element-276" />

      <div className="mb-8 sm:mb-10" data-id="element-277">
        <OfferSelector data-id="element-278" />
      </div>

      <div className="flex justify-center flex-wrap gap-4 sm:gap-5 text-gris text-[13px] mb-8 sm:mb-10" data-id="element-279">
        <span className="flex items-center gap-1.5" data-id="element-280">
          <Lock size={16} data-id="element-281" /> Pago seguro
        </span>
        <span className="flex items-center gap-1.5" data-id="element-282">
          <Zap size={16} data-id="element-283" /> Acceso en 5 min
        </span>
        <span className="flex items-center gap-1.5" data-id="element-284">
          <ShieldCheck size={16} className="text-verde" data-id="element-285" /> Garantía 7 días
        </span>
        <span className="flex items-center gap-1.5" data-id="element-286">
          <CreditCard size={16} data-id="element-287" /> Mercado Pago
        </span>
        <span className="flex items-center gap-1.5" data-id="element-288">
          <Download size={16} data-id="element-289" /> Descarga permanente
        </span>
      </div>

      <div className="max-w-[780px] mx-auto bg-white rounded-[20px] p-7 sm:p-9 shadow-[0_6px_30px_rgba(127,119,221,0.12)] border-[1.5px] border-violeta text-left" data-id="element-290">
        <h3 className="text-[20px] font-extrabold text-oscuro mb-2 text-center" data-id="element-291">
          ¿Qué agrega la Oferta Completa?
        </h3>
        <p className="text-[14px] text-gris text-center mb-5 sm:mb-7" data-id="element-292">
          Para esteticistas que quieren ir un paso más allá — más ingresos con
          las mismas clientas
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-5" data-id="element-293">
          <div data-id="element-294">
            <div className="text-[13px] text-gris mb-2 font-semibold" data-id="element-295">
              Sin Tomo 7 y 8
            </div>
            <div className="text-[13px] text-gris leading-[1.65] flex flex-col gap-2" data-id="element-296">
              <span data-id="element-297">
                ❌ Dependés de que las clientas se acuerden de volver solas
              </span>
              <span data-id="element-298">
                ❌ Sabés que deberías subir los precios pero no lo hacés
              </span>
              <span data-id="element-299">
                ❌ Ganancias iguales todos los meses sin saber cómo crecer
              </span>
            </div>
          </div>
          <div data-id="element-300">
            <div className="text-[13px] text-violeta mb-2 font-bold" data-id="element-301">
              Con Tomo 7 y 8
            </div>
            <div className="text-[13px] text-oscuro leading-[1.65] flex flex-col gap-2" data-id="element-302">
              <span data-id="element-303">
                ✅ Sistema de seguimiento que trae de vuelta a las clientas
                solas
              </span>
              <span data-id="element-304">
                ✅ Método con el mensaje exacto para subir precios sin perder a
                nadie
              </span>
              <span data-id="element-305">
                ✅ Hasta $108.000 más por mes con las mismas clientas de siempre
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}